import React from 'react';

const ConceptDetailSpan = (props) => {
    return <div className="flex-item">
        {props.title && <span className="item-title">{props.title}</span>}
        {props.data &&<span className={`item-data ${props.classNames}`}>{props.data.join(', ')}</span>}
    </div>
}

export default ConceptDetailSpan;